import { mapGetters, mapState } from 'vuex';
import reportWalker from '../utils/report_walker';

export default {
  computed: {
    ...mapState({
      notes: 'notes',
      reportData: 'report_data',
    }),
    ...mapGetters(['walker']),
    tableData() {
      return reportWalker(this.reportData, this.notes, this.walker);
    },
    hasTableData() {
      return this.tableData?.sections?.length > 0;
    },
    recordDateProperty() {
      if (this.$store.getters.walker.main_type === 'date') {
        return 'main';
      }
      if (this.$store.getters.walker.sub_type === 'date') {
        return 'sub';
      }
      if (this.$store.getters.walker.third_type === 'date') {
        return 'third';
      }
      if (this.$store.getters.walker.fourth_type === 'date') {
        return 'fourth';
      }
    },
  },
};
